import {
    AdjustBudget,
    QueryCustomerBudget,
    SaveDevelopBudget,
    QueryDevelopBudget,
    QueryInceraseBudget,
    QueryIncomeActual,
    SaveIncreaseBudget,
    RefreshTarget,
    RefreshTargetYear,
    UpdateCustomerYearTarget,
    MarkMonthAll
} from '../../request/budget';
export default {
    namespace: true,
    state: {},

    mutations: {},
    actions: {
        QUERY_CUSTOMER_BUDGET: async ({ commit }, payload) => {
            let res = await QueryCustomerBudget(payload);
            return res;
        },

        ADJUST_BUDGET: async ({ commit }, payload) => {
            let res = await AdjustBudget(payload);
            return res;
        },

        SAVE_DEVELOP_BUDGET: async ({ commit }, payload) => {
            let res = await SaveDevelopBudget(payload);
            return res;
        },

        QUERY_BUDGET_DEVELOP: async ({ commit }, payload) => {
            let res = await QueryDevelopBudget(payload);
            return res;
        },
        QUERY_INCREASE_BUDGET: async ({ commit }, payload) => {
            let res = await QueryInceraseBudget(payload);
            return res;
        },

        QUERY_INCOME_ACTUAL: async ({ commit }, payload) => {
            let res = await QueryIncomeActual(payload);
            return res;
        },

        SAVE_INCREASE_BUDGET: async ({ commit }, payload) => {
            let res = await SaveIncreaseBudget(payload);
            return res;
        },

        REFRESH_TARGET: async ({ commit }, payload) => {
            let res = await RefreshTarget(payload);
            return res;
        },

        REFRESH_TARGET_YEAR: async ({}, payload) => {
            let res = await RefreshTargetYear(payload);
            return res;
        },

        UPDATE_CUSTOMER_YEAR_TARGET: async ({}, payload) => {
            let res = await UpdateCustomerYearTarget(payload);
            return res;
        },
        MARK_MONTH_ALL: async ({}, payload) => {
            let res = await MarkMonthAll(payload);
            return res;
        }
    }
};
